var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlayBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 8492,
    transform: "translate(-1134 -5447)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 604,
    transform: "translate(-1134 -337)",
    fill: "url(#paint0_linear_2_4)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -13,
    y: -13,
    width: 58,
    height: 58,
    rx: 12,
    fill: "#7F56D9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5848 15.1378L15.2454 12.1346C14.6918 11.7519 14 12.2306 14 12.9969V19.0036C14 19.7694 14.6918 20.248 15.2454 19.8654L19.5848 16.8618C20.1384 16.4787 20.1384 15.5213 19.5848 15.1382V15.1378Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_4",
    x: -25,
    y: -17,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52849 0 0 0 0 0.566891 0 0 0 0 0.9125 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_4",
    x1: 1148.5,
    y1: 1311.69,
    x2: 714.938,
    y2: 120.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 8492,
    fill: "white",
    transform: "translate(-1134 -5447)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayBg);
export default __webpack_public_path__ + "static/media/ic_play_bg.b4a4991cf5fe33e041c312b5ab88dd45.svg";
export { ForwardRef as ReactComponent };